import { NgModule } from '@angular/core';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { TimeZoneComponent } from './time-zone/time-zone.component';
import { TranslateModule } from '@ngx-translate/core';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { MainComponentModule } from '../main-component/mainComponent.module';
import { DisplayCardTypeComponent } from '../../dumb-components/display-card-type/display-card-type.component';
import { PaymentMethodFormComponent } from '../main-component/payment-method-form/payment-method-form.component';
import { ShoppingCartComponent } from '../main-component/shopping-cart/shopping-cart.component';
import { ItemInventoryComponent } from '../main-component/item-inventory/item-inventory.component';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { KeyDownDirective } from '../../directives/keyDown.directive';
import { InputUpperCaseDirective } from '../../directives/input-to-upper-case.directive';
import { MatChipsModule } from '@angular/material/chips';
import { PageLayoutComponent } from '../../base-component/page-layout/page-layout.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { FullScreenLoaderComponent } from '../main-component/full-screen-loader/full-screen-loader.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MultilingualComponent } from '../main-component/multilingual/multilingual.component';

const angularMaterialModule = [
    MatListModule,
    MatRadioModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatTableModule,
    MatCheckboxModule,
    MatButtonModule,
    MatToolbarModule,
    MatTabsModule,
    MatCardModule,
    MatInputModule,
    MatSliderModule,
    MatSnackBarModule,
    MatDialogModule,
    MatChipsModule,
    MatToolbarModule
];
const directives = [
    KeyDownDirective,
    InputUpperCaseDirective
];

registerLocaleData(localeFr, 'fr');
@NgModule({
    declarations: [
        InfoModalComponent,
        TimeZoneComponent,
        DisplayCardTypeComponent,
        PaymentMethodFormComponent,
        ShoppingCartComponent,
        ItemInventoryComponent,
        FullScreenLoaderComponent,
        directives
    ],
    exports: [
        MultilingualComponent,
        InfoModalComponent,
        TimeZoneComponent,
        GoogleMapsModule,
        TranslateModule,
        DisplayCardTypeComponent,
        PaymentMethodFormComponent,
        ShoppingCartComponent,
        ItemInventoryComponent,
        FullScreenLoaderComponent,
        PageLayoutComponent,
        MatListModule,
        MatRadioModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatButtonToggleModule,
        MatTableModule,
        MatCheckboxModule,
        MatButtonModule,
        MatToolbarModule,
        MatTabsModule,
        MatCardModule,
        MatInputModule,
        MatSliderModule,
        MatSnackBarModule,
        MatDialogModule,
        MatChipsModule
    ], imports: [MultilingualComponent,
        NgxMaskDirective, NgxMaskPipe,
        MainComponentModule,
        GoogleMapsModule,
        angularMaterialModule,
        TranslateModule,
        PageLayoutComponent],
    providers: [
        provideNgxMask(),
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport())
    ]
})
export class SharedComponentModule { }
